import DayPart from "../../day-part";
import DayPartHelper from "../day-part-helper";

class DayPartWeekly extends DayPart {
  constructor(props) {
    super(props);
    this._helper = new DayPartHelper(props, "weeks");
  }

  _matchesWeekDay() {
    const weekdays = this._helper.repeatOptions?.weekdays;
    if (!weekdays) return false;
    return weekdays.includes(this._atTime.toFormat("EEEE").toLowerCase());
  }

  _matchesDay() {
    return super._matchesDay() && this._matchesWeekDay();
  }
}

export default DayPartWeekly;
